<div class="row p-5">
  <div class="col-12 d-flex justify-content-center">
    <div class="not-found-img"></div>
  </div>
  <div class="pt-2 col-12 d-flex justify-content-center">
    <div class="error-description">
      {{notResultsTitle || defaultTitleResultText}}
    </div>
  </div>
  <div class="pt--0_5 col-12 d-flex justify-content-center">
    <div *ngIf="notResultsTitleLine2" class="error-description">
      {{notResultsTitleLine2}}
    </div>
  </div>
  <div class="col-12 d-flex justify-content-center">
    <div class="error-instructions">
      {{notResultsSubTitle || defaultSubtitleResultText}}
    </div>
  </div>
  <div class="col-12 d-flex justify-content-center">
    <div class="error-instructions">
      {{notResultsSubSubTitle || ''}}
    </div>
  </div>
</div>
